/* eslint-disable */
import { Tabs, type TabsValue } from "@mantine/core";
import { useState } from "react";
import UserTableOrg from "../users/userTable";
import ProjectSuperAdmin from "../project/projects";
import ComingSoonPage from "components/comingSoon/comingSoon";
import SuperAdminDashboard from "../adminDashboard/adminDashboard";
import OrganizationSuper from "../organization/organization";
import SystemSuperAdmin from "../system/system";
import { AdminSettings } from "features/admin-settings";

const tabLabels = [
  "Overview",
  // "Projects",
  "Users",
  "Organizations",
  // "Admin Setting",
  "System",
];

export default function MantineTabs() {
  const [active, setActive] = useState<TabsValue>("Overview");

  return (
    <Tabs value={active} onTabChange={setActive} variant="pills" color="violet">
      <Tabs.List mb="md">
        {tabLabels?.map((label) => (
          <Tabs.Tab
            key={label}
            value={label}
            mr="lg"
            styles={(theme, { active }) => ({
              tab: {
                fontWeight: 500,
                padding: "0.5rem 1rem",
                borderRadius: theme.radius.xl,
                ...(active ? {} : { color: theme.colors.gray[6] }),
              },
            })}
          >
            {label}
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {tabLabels?.map((label) => (
        <Tabs.Panel key={label} value={label}>
          {label === "Users" && <UserTableOrg />}
          {label === "Overview" && <SuperAdminDashboard />}
          {/* {label === "Projects" && <ProjectSuperAdmin />} */}
          {label === "Organizations" && <OrganizationSuper />}
          {label === "System" && <SystemSuperAdmin />}
          {/* {label === "Admin Setting" && <AdminSettings />} */}
        </Tabs.Panel>
      ))}
    </Tabs>
  );
}
